import { Injectable } from '@angular/core';

/**
 * 牙科治療代碼對應類別 Service
 * 提供治療代碼與類別代碼的對應查詢功能
 */
@Injectable({
  providedIn: 'root'
})
export class DentalTreatmentCategoryService {

  /**
   * 治療代碼與類別代碼的對應表
   * Key: 治療代碼, Value: 類別代碼
   */
  private readonly treatmentCategoryMap: Map<string, string> = new Map([
    ['01003C', 'EE'],
    ['01004C', 'EE'],
    ['91021C', 'FP'],
    ['P4001C', 'FP'],
    ['91022C', 'FQ'],
    ['P4002C', 'FQ'],
    ['91023C', 'FR'],
    ['P4003C', 'FR'],
    ['G3', 'G3'],
    ['P7702C', 'HP'],
    ['P7703C', 'HP'],
    ['P7710B', 'HQ'],
    ['P6702C', 'LK'],
    ['P6703C', 'LK'],
    ['P6704C', 'LK'],
    ['P6705C', 'LK'],
    ['P7101C', 'LM'],
    ['P7102C', 'LM'],
    ['90001C', 'P1'],
    ['90002C', 'P1'],
    ['90003C', 'P1'],
    ['90009C', 'P1'],
    ['90010C', 'P1'],
    ['90011C', 'P1'],
    ['90013C', 'P1'],
    ['90014C', 'P1'],
    ['90015C', 'P1'],
    ['90017C', 'P1'],
    ['90018C', 'P1'],
    ['90018P', 'P1'],
    ['90019C', 'P1'],
    ['90020C', 'P1'],
    ['90091C', 'P1'],
    ['90092C', 'P1'],
    ['90093C', 'P1'],
    ['90094C', 'P1'],
    ['90095C', 'P1'],
    ['90096C', 'P1'],
    ['90097C', 'P1'],
    ['90098C', 'P1'],
    ['89001C', 'P2'],
    ['89002C', 'P2'],
    ['89003C', 'P2'],
    ['89101C', 'P2'],
    ['89102C', 'P2'],
    ['89103C', 'P2'],
    ['89004C', 'P3'],
    ['89005C', 'P3'],
    ['89008C', 'P3'],
    ['89009C', 'P3'],
    ['89010C', 'P3'],
    ['89011C', 'P3'],
    ['89012C', 'P3'],
    ['89013C', 'P3'],
    ['89014C', 'P3'],
    ['89015C', 'P3'],
    ['89104C', 'P3'],
    ['89105C', 'P3'],
    ['89108C', 'P3'],
    ['89109C', 'P3'],
    ['89110C', 'P3'],
    ['89111C', 'P3'],
    ['89112C', 'P3'],
    ['89113C', 'P3'],
    ['89114C', 'P3'],
    ['89115C', 'P3'],
    ['89204C', 'P3'],
    ['89205C', 'P3'],
    ['89208C', 'P3'],
    ['89209C', 'P3'],
    ['89210C', 'P3'],
    ['89212C', 'P3'],
    ['89214C', 'P3'],
    ['89215C', 'P3'],
    ['89304C', 'P3'],
    ['89305C', 'P3'],
    ['89308C', 'P3'],
    ['89309C', 'P3'],
    ['89310C', 'P3'],
    ['89312C', 'P3'],
    ['89314C', 'P3'],
    ['89315C', 'P3'],
    ['91001C', 'P4'],
    ['91006C', 'P4'],
    ['91007C', 'P4'],
    ['91008C', 'P4'],
    ['91011C', 'P4'],
    ['91012C', 'P4'],
    ['91018C', 'P4'],
    ['91019C', 'P4'],
    ['90005C', 'P5'],
    ['90016C', 'P5'],
    ['92002C', 'P7'],
    ['92003C', 'P7'],
    ['92004C', 'P7'],
    ['92012C', 'P7'],
    ['92013C', 'P7'],
    ['92014C', 'P7'],
    ['92015C', 'P7'],
    ['92016C', 'P7'],
    ['92017C', 'P7'],
    ['92027C', 'P7'],
    ['92028C', 'P7'],
    ['92029C', 'P7'],
    ['92030C', 'P7'],
    ['92031C', 'P7'],
    ['92032C', 'P7'],
    ['92033C', 'P7'],
    ['92041C', 'P7'],
    ['92042C', 'P7'],
    ['92050C', 'P7'],
    ['92055C', 'P7'],
    ['92065B', 'P7'],
    ['92067B', 'P7'],
    ['92068B', 'P7'],
    ['92071C', 'P7'],
    ['92090C', 'P7'],
    ['92091C', 'P7'],
    ['92092C', 'P7'],
    ['92095C', 'P7'],
    ['92096C', 'P7'],
    ['92097C', 'P7'],
    ['92098C', 'P7'],
    ['91003C', 'P8'],
    ['91004C', 'P8'],
    ['91005C', 'P8'],
    ['91014C', 'P8'],
    ['91015C', 'P8'],
    ['91016C', 'P8'],
    ['91017C', 'P8'],
    ['91020C', 'P8'],
    ['91089C', 'P8'],
    ['91090C', 'P8'],
    ['91091C', 'P8'],
    ['91103C', 'P8'],
    ['91104C', 'P8'],
    ['91114C', 'P8']
  ]);

  /**
   * 類別代碼說明對照表
   */
  private readonly categoryDescriptionMap: Map<string, string> = new Map([
    ['P1', '根管治療'],
    ['P2', '銀粉充填'],
    ['P3', '複合樹脂充填'],
    ['P4', '牙周病手術(含刮除術)'],
    ['P5', '兒童斷髓處理'],
    ['P6', '高壓氧治療'],
    ['P7', '口腔外科手術包括拔牙'],
    ['P8', '治療性牙結石清除'],
    ['P0', '常用主訴'],
    ['FP', '牙周病統合性治療第一階段'],
    ['FQ', '牙周病統合性治療第二階段'],
    ['FR', '牙周病統合性治療第三階段'],
    ['EE', 'COVID-19(武漢肺炎)之視訊診療'],
    ['LK', '0-6歲嚴重齲齒兒童口腔 健康照護試辦計畫'],
    ['LM', '12-18歲青少年口腔提升照 護試辦計畫']
  ]);

  /**
   * 類別代碼排序對照表（用於報表排序）
   */
  private readonly categoryOrderMap: Map<string, number> = new Map([
    ['P1', 1],
    ['P2', 2],
    ['P3', 3],
    ['P4', 4],
    ['P5', 5],
    ['P6', 6],
    ['P7', 7],
    ['P8', 8],
    ['P0', 9],
    ['FP', 10],
    ['FQ', 11],
    ['FR', 12],
    ['EE', 13],
    ['LK', 14],
    ['LM', 15]
  ]);

  constructor() { }

  /**
   * 根據治療代碼查詢對應的類別代碼
   * @param treatmentCode 治療代碼
   * @returns 類別代碼，若無對應則返回 null
   */
  getCategoryCode(treatmentCode: string): string | null {
    if (!treatmentCode) {
      return null;
    }
    return this.treatmentCategoryMap.get(treatmentCode) || null;
  }

  /**
   * 根據類別代碼查詢說明
   * @param categoryCode 類別代碼
   * @returns 類別說明，若無對應則返回 null
   */
  getCategoryDescription(categoryCode: string): string | null {
    if (!categoryCode) {
      return null;
    }
    return this.categoryDescriptionMap.get(categoryCode) || null;
  }

  /**
   * 根據治療代碼直接查詢類別說明
   * @param treatmentCode 治療代碼
   * @returns 類別說明，若無對應則返回 null
   */
  getCategoryDescriptionByTreatmentCode(treatmentCode: string): string | null {
    const categoryCode = this.getCategoryCode(treatmentCode);
    if (!categoryCode) {
      return null;
    }
    return this.getCategoryDescription(categoryCode);
  }

  /**
   * 檢查治療代碼是否存在於對應表中
   * @param treatmentCode 治療代碼
   * @returns 是否存在
   */
  hasTreatmentCode(treatmentCode: string): boolean {
    return this.treatmentCategoryMap.has(treatmentCode);
  }

  /**
   * 根據類別代碼取得所有對應的治療代碼
   * @param categoryCode 類別代碼
   * @returns 治療代碼陣列
   */
  getTreatmentCodesByCategory(categoryCode: string): string[] {
    const codes: string[] = [];
    this.treatmentCategoryMap.forEach((value, key) => {
      if (value === categoryCode) {
        codes.push(key);
      }
    });
    return codes;
  }

  /**
   * 取得所有類別代碼清單
   * @returns 類別代碼陣列（已去重）
   */
  getAllCategories(): string[] {
    const categories = new Set(this.treatmentCategoryMap.values());
    return Array.from(categories).sort();
  }

  /**
   * 取得所有治療代碼清單
   * @returns 治療代碼陣列
   */
  getAllTreatmentCodes(): string[] {
    return Array.from(this.treatmentCategoryMap.keys()).sort();
  }

  /**
   * 批次查詢多個治療代碼的類別代碼
   * @param treatmentCodes 治療代碼陣列
   * @returns 對應的類別代碼陣列（保持順序，無對應者為 null）
   */
  getCategoryCodes(treatmentCodes: string[]): (string | null)[] {
    return treatmentCodes.map(code => this.getCategoryCode(code));
  }

  /**
   * 根據類別代碼篩選治療代碼清單
   * @param treatmentCodes 治療代碼陣列
   * @param categoryCode 類別代碼
   * @returns 屬於指定類別的治療代碼陣列
   */
  filterByCategory(treatmentCodes: string[], categoryCode: string): string[] {
    return treatmentCodes.filter(code => this.getCategoryCode(code) === categoryCode);
  }

  /**
   * 取得完整對應表（以物件形式返回）
   * @returns 治療代碼與類別代碼的對應物件
   */
  getTreatmentCategoryMapping(): { [treatmentCode: string]: string } {
    const mapping: { [key: string]: string } = {};
    this.treatmentCategoryMap.forEach((value, key) => {
      mapping[key] = value;
    });
    return mapping;
  }

  /**
   * 根據類別代碼取得排序順序
   * @param categoryCode 類別代碼
   * @returns 排序順序號，若無對應則返回 999
   */
  getCategoryOrder(categoryCode: string): number {
    return this.categoryOrderMap.get(categoryCode) || 999;
  }

  /**
   * 根據排序順序對類別代碼進行排序
   * @param categoryCodes 類別代碼陣列
   * @returns 已排序的類別代碼陣列
   */
  sortCategoriesByOrder(categoryCodes: string[]): string[] {
    return [...categoryCodes].sort((a, b) => {
      return this.getCategoryOrder(a) - this.getCategoryOrder(b);
    });
  }

  /**
   * 取得所有類別資訊（包含代碼、說明、順序）並依順序排列
   * @returns 類別資訊陣列
   */
  getAllCategoryInfos(): Array<{ code: string; description: string; order: number }> {
    const infos: Array<{ code: string; description: string; order: number }> = [];
    this.categoryOrderMap.forEach((order, code) => {
      infos.push({
        code: code,
        description: this.getCategoryDescription(code) || '',
        order: order
      });
    });
    return infos.sort((a, b) => a.order - b.order);
  }
}
